var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Icon } from '@iconify/react';
/**
 * Express your skills using the Skill component.
 *
 * @props title: Main text that expresses the skill (default: 'javascript')
 * @props titleSize: Title size style (default: '24px')
 * @props titleColor: Title color style (default: 'black')
 * @props isHiddenTitle: If this value is set to True, you can hide the title. (default: false)
 * @props iconName: Enter the name of the icon you searched on the following site. (default: 'ion:logo-javascript') {@link https://icon-sets.iconify.design/}
 * @props iconSize: Icon size style (defualt: '40px')
 * @props iconColor: Icon color style (default: '#F0DB4F')
 * @props margin: Skill margin style (defualt: '0px')
 * @props padding: Skill padding style (defualt: '0px')
 * @props backgroundColor: Skill background color style (default: 'white')
 * @props borderColor: Skill border color style (default: 'white')
 * @props borderRadius: Skill border-radius style (default: '12px')
 */
var Skill = function (_a) {
    var title = _a.title, titleSize = _a.titleSize, titleColor = _a.titleColor, isHiddenTitle = _a.isHiddenTitle, iconName = _a.iconName, iconSize = _a.iconSize, iconColor = _a.iconColor, margin = _a.margin, padding = _a.padding, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, borderRadius = _a.borderRadius;
    return (_jsxs(Container, __assign({ margin: margin, padding: padding, backgroundColor: backgroundColor, borderColor: borderColor, borderRadius: borderRadius }, { children: [_jsx(Icon, { icon: "".concat(iconName === null || iconName === void 0 ? void 0 : iconName.toLowerCase()), fontSize: iconSize, color: iconColor }), _jsx(Name, __assign({ titleSize: titleSize, titleColor: titleColor, isHiddenTitle: isHiddenTitle }, { children: title }))] })));
};
export default Skill;
Skill.defaultProps = {
    title: 'Javascript',
    titleSize: '24px',
    titleColor: 'black',
    isHiddenTitle: false,
    iconName: 'ion:logo-javascript',
    iconSize: '40px',
    iconColor: '#F0DB4F',
    margin: '0px',
    padding: '0px',
    backgroundColor: 'white',
    borderColor: 'white',
    borderRadius: '12px',
};
var Container = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: ", ";\n  padding: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: ", ";\n  padding: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n"])), function (_a) {
    var margin = _a.margin;
    return margin;
}, function (_a) {
    var padding = _a.padding;
    return padding;
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var borderColor = _a.borderColor;
    return borderColor;
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return borderRadius;
});
var Name = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: ", ";\n  margin-left: 8px;\n  font-size: ", ";\n  font-weight: bold;\n  color: ", ";\n"], ["\n  display: ", ";\n  margin-left: 8px;\n  font-size: ", ";\n  font-weight: bold;\n  color: ", ";\n"])), function (_a) {
    var isHiddenTitle = _a.isHiddenTitle;
    return (isHiddenTitle ? 'none' : 'flex');
}, function (_a) {
    var titleSize = _a.titleSize;
    return titleSize;
}, function (_a) {
    var titleColor = _a.titleColor;
    return titleColor;
});
var templateObject_1, templateObject_2;
